'use client'
import store from "@/redux/store";
import { useState, useEffect } from 'react'
import { Dialog, DialogBackdrop, DialogPanel, DialogTitle } from '@headlessui/react'
import { ExclamationTriangleIcon } from '@heroicons/react/24/outline'

import { SelectBox } from "@/components/holders/SelectBox";
import AddInvoiceRowTimeRegistration from './AddInvoiceRow_TimeRegistration';
import AddInvoiceRowFree from './AddInvoiceRow_Free';
import { getInvoiceFilters, getTimeRegistrationForCustomer } from "@/reducers/Invoice";
import DB from "@/models/DB";
import {InvoiceRow} from "@/models/InvoiceRow";

export default function AddInvoiceRow({...props}) {
    
  const [open, setOpen] = useState(true)
    const [typeInvoiceRow, setTypeInvoiceRow] = useState( {id:0, name: ""} );
    const [dataTypeRow, setDataTypeRow] = useState({})
    const [invoiceRow, setInvoiceRow] = useState();
    let selectedVatRate = props.modalOptions.vatrates[0];
    let rowTypePanel = null;
    const invoiceRowTypes = [
        {id:2, name: "Vrije invoer"}
    ]

    if( (props.modalOptions.customer && props.modalOptions.customer.hasTimeRegistrations) || (invoiceRow instanceof InvoiceRow && invoiceRow.invoice_type == "3") ) {
        invoiceRowTypes.push( {id:3, name: "Tijd registratie"} )
    }

    useEffect(() => {
        if(props.modalOptions?.invoiceRow && !invoiceRow) {
            let invoiceRowItem = props.modalOptions?.invoiceRow;
            setInvoiceRow(invoiceRowItem);
            setTypeInvoiceRow({id: invoiceRowItem.invoice_type, name: invoiceRowItem.invoice_type_name});
        }
        return () => {
        };
      }, [props, setInvoiceRow, setDataTypeRow, selectedVatRate]);
    
        
    const updateInvoiceRow = (newInvoiceRow) => {
        setInvoiceRow(newInvoiceRow);
    }
    
   const setValueCombobox= (name, selected) => {
        let newInvoiceRow = DB.newModel( null, InvoiceRow );

        newInvoiceRow.invoice_type = selected.id;
        newInvoiceRow.invoice_type_name = selected.name;
        
        newInvoiceRow.setVatRate(selectedVatRate);
       if(selected.id == 3) {
        const state = store.getState();
        const {InvoiceReducer} = state;
        const {customertimereg} = InvoiceReducer;
        
        if(!customertimereg) {
            store.dispatch( getInvoiceFilters({data:{}, customerKey:props.modalOptions.customer.key}))
                 .unwrap()
                 .then((data) => {
                    //invoiceRow = DB.newModel( null, InvoiceRow );
                    //
                    newInvoiceRow.timeregistrations = data;
                    setInvoiceRow(newInvoiceRow);
//                    
                     //setDataTypeRow(data.data);
                     setTypeInvoiceRow(selected);
                 })
                 .catch((error) => { return error;} )
            } else {
                                    newInvoiceRow.timeregistrations = customertimereg;
                                    setInvoiceRow(newInvoiceRow);
                //                    
                                     //setDataTypeRow(data.data);
                                     setTypeInvoiceRow(selected);
                
            }
       } else {
        setInvoiceRow(newInvoiceRow);
       setTypeInvoiceRow(selected);
       }
   }
   
    const getRowTypePanel = () => {
        if(typeInvoiceRow) {
       switch(typeInvoiceRow.id) {
           case 2:
               rowTypePanel = (<AddInvoiceRowFree key={typeInvoiceRow.id}  vatrates={props.modalOptions.vatrates} selectedVat={selectedVatRate} invoiceRow={invoiceRow} updateInvoiceRowHandler={updateInvoiceRow}/>);
               break;
           case 3:
                //let invoiceRow = DB.newModel( null, InvoiceRow );
               rowTypePanel = (<AddInvoiceRowTimeRegistration key={typeInvoiceRow.id} updateInvoiceRowHandler={updateInvoiceRow} invoiceRow={invoiceRow} vatrates={props.modalOptions.vatrates} selectedVat={selectedVatRate} customer={props.modalOptions.customer}/>);
               break;
               
       }
       }
        return rowTypePanel;
    }

const handleSubmitFields = (event) => {
  event.preventDefault();
//  var formData = new FormData(event.target);
//  let cleanFormData = Object.fromEntries(formData);
//  
//  
        if(props.modalOptions && props.modalOptions.action) {
            
            props.modalOptions.action(invoiceRow, dataTypeRow);
        }
    
    
    
  return false;
}
    
  return (
    <Dialog open={open} onClose={() => {return;}} className="relative z-10" >
      <DialogBackdrop
        transition
        className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in"
      />

      <div className="fixed inset-0 z-10 w-screen overflow-y-auto">
        <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
          <DialogPanel
            transition
            className="relative transform  rounded-lg bg-white px-4 pb-4 pt-5 text-left shadow-xl transition-all data-[closed]:translate-y-4 data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in sm:my-8 sm:w-full sm:max-w-3xl sm:p-6 data-[closed]:sm:translate-y-0 data-[closed]:sm:scale-95"
          >

    <form onSubmit={(event) => handleSubmitFields(event)}>

      <div className="space-y-12 sm:space-y-16">
        <div>
          <h2 className="text-base font-semibold leading-7 text-gray-900">Factuur regel {props.modalOptions?.mode == 'new' ? 'toevoegen' : 'aanpassen'}</h2>
{props.modalOptions?.mode == 'new' && 
          <div className="mt-10 space-y-8 border-b border-gray-900/10 pb-12 sm:space-y-0 sm:divide-y sm:divide-gray-900/10 sm:border-t sm:pb-0">
            <div className="sm:grid sm:grid-cols-3 sm:items-start sm:gap-4 sm:py-6">
              <label htmlFor="username" className="block text-sm font-medium leading-6 text-gray-900 sm:pt-1.5">
                Type regel
              </label>
              <div className="mt-2 sm:col-span-2 sm:mt-0">
                <input type="hidden" defaultValue={(typeInvoiceRow) ? typeInvoiceRow.id : null} name="invoice_type" />
                <input type="hidden" defaultValue={(typeInvoiceRow) ? typeInvoiceRow.name : null} name="invoice_type_name" />
                <SelectBox key={typeInvoiceRow.id} className="" label="" name="invoice_type" keyid="id" data={invoiceRowTypes} selected={typeInvoiceRow} boxfield="name" placeHolder="Selecteer type factuur regel" changeEvent={(name, val) => setValueCombobox(name,val)}/>                
              </div>
            </div>
           </div>
            }
            {getRowTypePanel()}

          </div> 
        </div>


            <div className="mt-5 sm:mt-4 sm:flex sm:flex-row-reverse">
            {props.modalOptions?.mode == 'edit'&&   
                <>         
            <button
              type="submit"
              //onClick={() => confirmEvent(event)}
              className="inline-flex w-full justify-center rounded-md bg-red-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-red-500 sm:ml-3 sm:w-auto"
            >
              Verwijderen
            </button>
            <button
              type="submit"
              //onClick={() => confirmEvent(event)}
              className="inline-flex w-full justify-center rounded-md bg-blue-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-blue-500 sm:ml-3 sm:w-auto"
            >
              Aanpassen
            </button>
            </>
            }
            {props.modalOptions?.mode == 'new'&&
              <button
                type="submit"
                //onClick={() => confirmEvent(event)}
                className="inline-flex w-full justify-center rounded-md bg-blue-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-blue-500 sm:ml-3 sm:w-auto"
              >
                Toevoegen
              </button>
              }
              <button
                type="button"
                data-autofocus
                onClick={() => setOpen(false)}
                className="mt-3 inline-flex w-full justify-center rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50 sm:mt-0 sm:w-auto"
              >
                Annuleer
              </button>
            </div>
       </form>
          </DialogPanel>
        </div>
      </div>
    </Dialog>
  )
}
